<template>
  <div class="recherche_area">
    <div id="find_what">
      <a-button
        @click="searchWhat = 'A'"
        type="ghost"
        shape="round"
        size="large"
        :style="[
          searchWhat == 'A'
            ? { backgroundColor: 'teal', color: 'white' }
            : { backgroundColor: 'white' },
        ]"
        style="margin: 20px"
      >
        Assuré
      </a-button>

      <a-button
        @click="searchWhat = 'E'"
        type="ghost"
        shape="round"
        size="large"
        :style="[
          searchWhat == 'E' ? { backgroundColor: 'brown', color: 'white' } : {},
        ]"
        style="margin: 20px"
      >
        Entreprise
      </a-button>
    </div>

    <div class="search_input">
      <a-input-search
        v-model:value="searchInput"
        style="border-radius: 50px"
        size="large"
        :placeholder="placeHolder"
        :disabled="showAssureInfo"
      ></a-input-search>
      <div v-if="loading" style="position: absolute; right: 40px; top: 40px">
        <a-spin></a-spin>
      </div>
      <!-- <div v-else>
        <div v-if="noResult" id="no_result"></div>
        Aucune résultat
      </div> -->
    </div>

    <AssureInfo v-if="showAssureInfo" />

    <div v-else class="search_result">
      <div v-if="searchWhat == 'A'">
        <div
          v-for="a in searchedAssures"
          :key="a.uuid"
          @click="
            getAssureInfo(
              a.holding_internal_number,
              a.company_internal_number,
              a.social_security_number
            )
          "
          class="a_card"
          :style="[
            a.active
              ? {
                  borderBottom: '2px solid green',
                }
              : {
                  borderBottom: '2px solid red',
                },
          ]"
        >
          <div style="font-size: 1.2em">
            <strong>{{ a.last_name }}</strong> {{ a.first_name }}
          </div>
          <div style="color: grey">
            {{ a.social_security_number }}
          </div>
        </div>
      </div>

      <div v-if="searchWhat == 'E'">
        <div
          v-for="a in searchedCompanies"
          @click="
            getEntrepriseInfo(a.holding_internal_number, a.internal_number)
          "
          :key="a.uuid"
          class="e_card"
          :style="[
            a.active
              ? {
                  borderBottom: '2px solid green',
                }
              : {
                  borderBottom: '2px solid red',
                },
          ]"
        >
          <div style="font-size: 1.2em; font-weight: bold">
            {{ a.name }} {{ a.n }}
          </div>
          <div style="font-size: 0.9em">
            <div class="description">
              Adresse : {{ a.address }} {{ a.additional_address }}
            </div>
            <div class="description">Ville : {{ a.city }}</div>
            <div class="description">Code postal : {{ a.zip_code }}</div>
            <a-divider></a-divider>
            <div class="description">Siret : {{ a.siret }}</div>
            <div class="description">Code NAF : {{ a.code_naf }}</div>
            <div class="description">N° client : {{ a.internal_number }}</div>
            <div class="description">
              Code initial espace entreprise : {{ a.code_init }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssureInfo from "@/components/AssureInfo";

export default {
  name: "search",
  components: {
    AssureInfo,
  },
  data() {
    return {
      loading: false,
      searchInput: "",

      assuresData: [],
      companiesData: [],
      timeout: null,
      _timeOut: 2000,

      searchWhat: "A",
      placeHolder: "Nom, Prenom, Numéro de sécurité sociale ...",

      params: {
        type: "SEARCH",
        searchValue: "",
      },
    };
  },
  watch: {
    searchWhat(sw) {
      this.result = [];
      this.searchInput = "";
      if (sw === "A") {
        this.placeHolder = "Nom, Prenom, Numéro de sécurité sociale ...";
      }
      if (sw === "E") {
        this.placeHolder = "Nº client, Nº Siret, Raison social ...";
      }
    },
    searchInput() {
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.searchWhat === "A") {
          this.searchAssure();
        }

        if (this.searchWhat === "E") {
          this.searchCompany();
        }
      }, 500);
    },
  },
  methods: {
    searchAssure() {
      this.params.searchValue = this.searchInput;

      this.axios
        .get(`data/assures?${new URLSearchParams(this.params)}`)
        .then((r) => {
          if (r.status === 200) {
            this.assuresData = r.data;

            setTimeout(() => {
              this.loading = false;
            }, 0);
          }
        });
    },
    searchCompany() {
      this.params.searchValue = this.searchInput;

      this.axios
        .get(`data/companys/x/xx/?${new URLSearchParams(this.params)}`)
        .then((r) => {
          if (r.status === 200) {
            this.companiesData = r.data;

            setTimeout(() => {
              this.loading = false;
            }, 0);
          }
        });
    },
    getAssureInfo(holdingIN, companyIN, numSS) {
      this.$router.push({
        name: "search",
        params: {
          holdingIN,
          companyIN,
          numSS,
        },
      });
    },
    getEntrepriseInfo(numHolding, numEntreprise) {
      this.$router.push({
        name: "portefeuille",
        params: {
          subPage: "ec",
          numHolding: numHolding,
          numEntreprise: numEntreprise,
        },
      });
    },
  },
  computed: {
    searchedAssures() {
      return this.assuresData.filter((a) => {
        return a;
      });
    },
    searchedCompanies() {
      return this.companiesData.filter((a) => {
        return a;
      });
    },
    noResult() {
      return this.searchInput.trim() != "" && this.assuresData.length === 0;
    },
    searchResultNumber() {
      return this.result.length;
    },
    showAssureInfo() {
      return !!this.$route.params.numSS && this.searchWhat === "A";
    },
  },
};
</script>
<style media="screen">
.recherche_area {
  padding: 70px 10px 0 70px;
  position: relative;
}
div#find_what {
  text-align: center;
}
div#no_result {
  font-size: 2em;
  margin: 30px 0;
  text-align: center;
  color: gray;
}
.search_input {
  padding: 30px 0;
  width: 420px;
  margin: auto;
  position: relative;
}
.search_result {
  margin: 0 20px 0 10px;
  text-align: center;
}
div#searchResultNumber {
  margin: 5px 0 0 4px;
  color: #565656;
  text-shadow: 0 0 1px #bfbfbf;
}
.a_card {
  width: 300px;
  box-shadow: 0 0 2px 0 grey;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: white;
  min-height: 70px;
  display: inline-block;
  text-align: left;
  cursor: pointer;
}
.e_card {
  width: 400px;
  box-shadow: 0 0 2px 0 grey;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: white;
  min-height: 130px;
  display: inline-block;
  text-align: left;
  vertical-align: top;
  cursor: pointer;
}
div#userInfo {
  width: 800px;
  margin: auto;
  min-height: 600px;
  background-color: white;
  padding: 20px;
  box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
  border-radius: 6px;
  position: relative;
}
.ferme {
  position: absolute;
  right: 8px;
  top: 10px;
  padding-bottom: 13px;
  border-bottom: 2px solid;
}
</style>
